export class Api {
    public static readonly BaseUrl: string = '/api/';
    public version!: string;
    constructor(ver: string) {
      this.version = ver;
    }
}
